import Notification from "antd/es/notification";
import "antd/es/notification/style/index.css";

export default Notification;
